
import axios from '../../helpers/axios';


export const updatedRegion = (id, updateRegion) => axios.patch(`/region/update/${id}`, updateRegion)
export const deletedRegion = (id) => axios.delete(`/region/delete/${id}`)
